/**
 * Created by kahn on 2018/10/09.
 */
import Axios from 'axios';
import { Spin } from 'view-design';

let loading;
/**
 * 显示loading层
 * @param   [{string}]    text    [加载效果的文案提示，非必填]
 */
const showLoading = (text = 'loading...') => {
    return loading = Spin.show({
        render: (h) => {
            return h('div', [
                h('Icon', {
                    'class': 'demo-spin-icon-load',
                    props: {
                        type: 'ios-loading',
                        size: 18
                    }
                }),
                h('div', text)
            ])
        }
    });
};

/**
 * 关闭loading层
 */
const closeLoading = () => {
    return Spin.hide();
}

/**
 * 各类校验集合fn
 * @param   [{string/number}]   p    [校验内容，必填]
 * @param   [{string}]    t    [校验类型，非必填]
 */
const regExp = (p, t = 'mp') => {        // 正則判断
    switch(t){
        case 'mp':                      // 驗證手機號
            return /^1[2,3,4,5,6,7,8,9]{1}[0-9]{9}$/.test(p);
        case 'tel':                     // 座机号
            return /^0[\d]{2,3}-[\d]{7,8}$/.test(p);
        case 'id':
            return /^[1-9]\d{5}[1-9]\d{3}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{3}(\d|x|X)$/.test(p);
        default:
            return;
    }
};
//获取小时 分钟前
const getTime = (timespan) => {
    let dateTime = new Date(timespan);
    let year = dateTime.getFullYear();
    let month = dateTime.getMonth() + 1;
    let day = dateTime.getDate();
    let hour = dateTime.getHours();
    let minute = dateTime.getMinutes();
    let second = dateTime.getSeconds();
    let now = new Date();
    let now_new = Date.parse(now.toDateString());  //typescript转换写法
    let milliseconds = 0;
    let timeSpanStr;

    milliseconds = now_new - timespan;

    if (milliseconds <= 1000 * 60 * 1) {
        timeSpanStr = '刚刚';
    }
    else if (1000 * 60 * 1 < milliseconds && milliseconds <= 1000 * 60 * 60) {
        timeSpanStr = Math.round((milliseconds / (1000 * 60))) + '分钟前';
    }
    else if (1000 * 60 * 60 * 1 < milliseconds && milliseconds <= 1000 * 60 * 60 * 24) {
        timeSpanStr = Math.round(milliseconds / (1000 * 60 * 60)) + '小时前';
    }
    else if (1000 * 60 * 60 * 24 < milliseconds && milliseconds <= 1000 * 60 * 60 * 24 * 15) {
        timeSpanStr = Math.round(milliseconds / (1000 * 60 * 60 * 24)) + '天前';
    }
    else if (milliseconds > 1000 * 60 * 60 * 24 * 15 && year == now.getFullYear()) {
        timeSpanStr = month + '-' + day + ' ' + hour + ':' + minute;
    } else {
        timeSpanStr = year + '-' + month + '-' + day + ' ' + hour + ':' + minute;
    }
    console.log(timeSpanStr,11)
    return timeSpanStr;
}
/**
 * 函数节流 防止连续重复调用
 * @param   [{function}]   fn    [要执行函数]
 * @param   [{number}]   t    [控制节流的周期]
 */
const throttle = (fn, t = 500) => {
    let last, timer, interval = t;
    return function () {
        let args = arguments;
        let now = +new Date();
        if (last && now - last < interval) {
            clearTimeout(timer);
            timer = setTimeout(() => {
                last = now;
                fn.apply(this, args);
            }, interval);
        } else {
            last = now;
            fn.apply(this, args);
        }
    }
}

/**
 * 判断是否滚动到底部指定距离
 * @param   [{number}]   t    [指定底部距离]
 */
const isAccessBottom = (t = 30) => {
    let height = Math.min(document.body.clientHeight, document.body.clientHeight),//内容高度
        scrollTop = document.documentElement.scrollTop || document.body.scrollTop,//滚动条偏移量
        windowH = Math.min(window.innerHeight, window.innerHeight);//窗口高度
    if(((scrollTop + windowH) > height - t)){
        return true;
    }else {
        return false;
    }
}

/**
 * 加法运算，避免数据相加小数点后产生多位数和计算精度损失。
 * 
 * @param num1加数1 | num2加数2
 */
const numAdd = (num1, num2) => {
    let baseNum, baseNum1, baseNum2;
    try {
        baseNum1 = num1.toString().split(".")[1].length;
    } catch (e) {
        baseNum1 = 0;
    }
    try {
        baseNum2 = num2.toString().split(".")[1].length;
    } catch (e) {
        baseNum2 = 0;
    }
    baseNum = Math.pow(10, Math.max(baseNum1, baseNum2));
    return (num1 * baseNum + num2 * baseNum) / baseNum;
};

/**
 * 减法运算，避免数据相减小数点后产生多位数和计算精度损失。
 * 
 * @param num1被减数  |  num2减数
 */
const numSub = (num1, num2) => {
    let baseNum, baseNum1, baseNum2;
    let precision;// 精度
    try {
        baseNum1 = num1.toString().split(".")[1].length;
    } catch (e) {
        baseNum1 = 0;
    }
    try {
        baseNum2 = num2.toString().split(".")[1].length;
    } catch (e) {
        baseNum2 = 0;
    }
    baseNum = Math.pow(10, Math.max(baseNum1, baseNum2));
    precision = (baseNum1 >= baseNum2) ? baseNum1 : baseNum2;
    return ((num1 * baseNum - num2 * baseNum) / baseNum).toFixed(precision);
};
/**
 * 乘法运算，避免数据相乘小数点后产生多位数和计算精度损失。
 * 
 * @param num1被乘数 | num2乘数
 */
const numMulti = (num1, num2, precision = 2) => {
    let baseNum = 0;
    try {
        baseNum += num1.toString().split(".")[1].length;
    } catch (e) {
    }
    try {
        baseNum += num2.toString().split(".")[1].length;
    } catch (e) {
    }
    return (Number(num1.toString().replace(".", "")) * Number(num2.toString().replace(".", "")) / Math.pow(10, baseNum)).toFixed(precision);
};
/**
 * 除法运算，避免数据相除小数点后产生多位数和计算精度损失。
 * 
 * @param num1被除数 | num2除数
 */
const numDiv = (num1, num2, precision = 2) => {
    let baseNum1 = 0, baseNum2 = 0;
    let baseNum3, baseNum4;
    try {
        baseNum1 = num1.toString().split(".")[1].length;
    } catch (e) {
        baseNum1 = 0;
    }
    try {
        baseNum2 = num2.toString().split(".")[1].length;
    } catch (e) {
        baseNum2 = 0;
    }
    baseNum3 = Number(num1.toString().replace(".", ""));
    baseNum4 = Number(num2.toString().replace(".", ""));
    return ((baseNum3 / baseNum4) * Math.pow(10, baseNum2 - baseNum1)).toFixed(precision);
};


/**
 * 设置背景色
 * @param   [{stirng}]   color    [要设置的颜色]
 */
const setBodyBackgroundColor = (color = '#fff') => {
    document.querySelector('body').setAttribute('style', `background-color: ${color}`);
}

/**
 * 还原设置的背景色
 */
const clearBodyBackgroundColor = () => {
    document.querySelector('body').removeAttribute('style');
}






export { showLoading, closeLoading, regExp, throttle, isAccessBottom, numAdd, numSub, numMulti, numDiv, setBodyBackgroundColor, clearBodyBackgroundColor, getTime }


// WEBPACK FOOTER //
// ./src/js/lib/utils.js